/* eslint-disable eqeqeq */
import React, { useState, useEffect, useCallback, useRef, lazy, Suspense } from 'react';
import ReactDOM from "react-dom/client"
import Navbar from './components_android/NavbarAndroid'
import Tasks from './pages_android/TasksAndroid'
import './css_android/style_android.css';
import moment from 'moment'
import 'moment/locale/ru'
import { getUrlParameter, getHttpParams } from './pages_android/custom_views/insta_custom_views/utils_android/UrlHelperAndroid';
import {saveRegistrCookie, getGoogleId, getRequestParams, getIsUpmobKey, isShowClose, saveApiKey, setCookie, saveBundle, getCookie} from './pages_android/custom_views/insta_custom_views/utils_android/CookieHelper'
import Loader from './pages_android/custom_views/insta_custom_views/utils_android/LoaderAndroid';
import { registrationFailed, showAndroidToast } from './pages_android/custom_views/insta_custom_views/utils_android/AndroidMethods';
import { YMInitializer } from 'react-yandex-metrika';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { convertNeedReworkOrders, getAndroidVersion, getIsAndroidApp, isShowBottomMenu, Pages } from './pages_android/custom_views/insta_custom_views/utils_android/UtilsAndroid';
import BottomMenu from './components_android/BottomMenu';
import { UsersApi } from './components_android/api/UsersApi';
import Auth from './pages_android/Auth';
import { GoogleOAuthProvider } from "@react-oauth/google"
import Toast from './pages_android/custom_views/insta_custom_views/utils_android/Toast';
import { TasksApi } from './components_android/api/TasksApi';

// Code-splitting: эти экраны грузятся отдельными чанками по требованию,
// чтобы не раздувать стартовый бандл (важно для слабых WebView).
const ActiveTasks = lazy(() => import('./pages_android/ActiveTasksAndroid'))
const FinishedTasks = lazy(() => import('./pages_android/FinishedTasksAndroid'))
const Task = lazy(() => import('./pages_android/TaskAndroid'))
const Referals = lazy(() => import('./pages_android/ReferalsAndroid'))
const Payouts = lazy(() => import('./pages_android/PayoutsAndroid'))
const GetPayout = lazy(() => import('./pages_android/GetPayoutAndroid'))
const Support = lazy(() => import('./pages_android/SupportAndroid'))
const AuthInsta = lazy(() => import('./pages_android/AuthInstaAndroid'))
const EarnInsta = lazy(() => import('./pages_android/EarnInstaAndroid'))
const CustomTask = lazy(() => import('./pages_android/CustomTask'))
const EarnTikTok = lazy(() => import('./pages_android/EarnTikTok'))
const Profile = lazy(() => import('./pages_android/ProfileAndroid'))
const More = lazy(() => import('./pages_android/MoreAndroid'))
const NeedRework = lazy(() => import('./pages_android/NeedRework'))
const TaskNewAndroid = lazy(() => import('./pages_android/TaskNewAndroid'))
const TaskIos = lazy(() => import('./pages_android/TaskIos'))
const FileUploadPage = lazy(() => import('./pages_android/FIleUploadPage'))

// В WebView каждый console.log сериализуется и уходит через JNI-мост в logcat,
// что заметно тормозит интерфейс. В проде глушим отладочные логи, оставляя error/warn.
// На localhost логи сохраняются для разработки.
if (!window.location.href.includes("localhost")) {
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
}

window.$moneyCount = 0.0;
moment.locale('ru')
function Application() {
    const [needReworkTasks, setNeedReworkTasks] = useState([])
    useEffect(() => {
        const isUnauthorized = !getIsAndroidApp() && !getCookie("google_user_id") && !getUrlParameter("google_user_id");
        const currentPath = window.location.pathname;
        // Ссылки на файлы (например /youtube_icons/order_type_other.svg) — это не роуты
        // приложения, их нельзя перехватывать и редиректить на /tasks.
        if (/\.[a-z0-9]+$/i.test(currentPath)) {
            return;
        }
        const isAuthPath = currentPath.includes(Pages.auth);
        const isTasksPath = currentPath.includes(Pages.tasks);
        const isValidRoute = Array.from(document.querySelectorAll('Route')).some(route => 
            route.props.path.replace('/', '') === currentPath.replace('/', '')
        );
        if (getUrlParameter("file_upload") == "true"){
            setState(prev => ({
                ...prev,
                done: true
            }));
            return
        }
        if (!getIsAndroidApp() && (currentPath === "/" || !isValidRoute) && !isAuthPath && !isUnauthorized && !isTasksPath) {
            window.location.href = Pages.tasks;
        }

        
    }, []);

    const getInitialState = () => {
        const hashId = !getGoogleId("google_user_id");
        const hasApiKey = getUrlParameter("api_key");
        const api_key = getUrlParameter("api_key") ? getUrlParameter("api_key") : getCookie("api_key");
        const webview_fits = getUrlParameter("webview_fits");
        if (webview_fits == "true" && !getCookie("webview_fits")){
            setCookie("webview_fits", "true")
        }
        const isUpmob = hasApiKey ? ["upmob", "upmob_rustore", "lexus", "QWT", "QWT2"].includes(api_key) : true;

        if (api_key) {
            saveApiKey(api_key);
        }

        return {
            count_money_r: 0.0,
            nick_name: "",
            photo_url: "",
            email: "",
            google_user_id: "",
            info: {},
            done: false,
            timestamp: "",
            isUpmob: hashId ? isUpmob : getIsUpmobKey(),
            // isUpmob: false,
            ref_id: "",
            isClose: hashId ? (hasApiKey ? getUrlParameter("api_key") : false) : isShowClose(),
            activeView: 'tasks',
            currentTask: {},
            backView: undefined,
            isMenuOpened: false,
            instagram_user_name: "",
            isRegistered: !hashId
        };
    };
    // const androidVersion = getAndroidVersion()
    // console.log("androidVersion = ", androidVersion)
    // Ленивая инициализация: getInitialState содержит побочные эффекты
    // (saveApiKey, setCookie) — передаём ссылку, чтобы React вызвал её один раз
    // при монтировании, а не на каждом рендере.
    const [state, setState] = useState(getInitialState);
    const [toastText, setToastText] = useState("")
    const navigate = useNavigate();

    const updateMoney = useCallback((money) => {
        // var mMoney = money
        // if (money >= 25){
        //     mMoney = Math.floor(mMoney / 25)
        // }
        console.log("updateMoney = ", money)
        setState(prev => ({
            ...prev,
            count_money_r: prev.count_money_r + parseFloat(money)
        }));
    }, []);

    const setMoney = useCallback((money) => {
        setState(prev => ({ ...prev, count_money_r: money }));
    }, []);

    const onTaskClicked = useCallback((task, path) => {
        setState(prev => ({
            ...prev,
            currentTask: task
        }));
        navigate(path + "?task_id=" + (task.order_id ? task.order_id : task._id));
    }, [navigate]);

    const toogleMenu = useCallback(() => {
        setState(prev => ({
            ...prev,
            isMenuOpened: !prev.isMenuOpened
        }));
    }, []);

    const onBack = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    const onMenuClicked = useCallback((path) => {
        setState(prev => ({
            ...prev,
            isMenuOpened: false
        }));
        navigate(path);
    }, [navigate]);

    const openViewBack = useCallback((path) => {
        navigate(path);
    }, [navigate]);

    const onPayoutClicked = useCallback(() => {
        navigate('/payout');
    }, [navigate]);

    const getMyInfo = useCallback(() => {
        setState(prev => ({ ...prev, done: false }));
        
        UsersApi.getMyInfoEmployer((responseData) => {
            
            if (responseData.response > 0) {
                    setState(prev => ({
                        ...prev,
                        isRegistered: true,
                        count_money_r: responseData.employer.count_money_r,
                        nick_name: responseData.employer.nick_name,
                        photo_url: responseData.employer.photo_url,
                        email: responseData.employer.email,
                        google_user_id: responseData.employer.google_user_id,
                        info: responseData.employer,
                        ref_id: responseData.employer.ref_id,
                        wallet_new: responseData.employer.wallet_new,
                        min_transfer: responseData.employer.min_transfer,
                        instagram_user_name: responseData.employer.instagram_user_name,
                        done: true
                    }));
                    getMyNeedRework(responseData.employer)
                    // if (getUrlParameter("uniq_user_id") && (responseData.employer.easy_money_user_id == "undefined" || responseData.employer.easy_money_user_id == null || responseData.employer.easy_money_user_id == "" || responseData.employer.easy_money_user_id == undefined)) {
                    //     registerUser();
                    // }

                    const hasApiKey = getUrlParameter("api_key");
                    const api_key = getUrlParameter("api_key") ? getUrlParameter("api_key") : getCookie("api_key");
                    const isUpmob = hasApiKey ? ["upmob", "upmob_rustore", "lexus", "QWT", "QWT2"].includes(api_key) : true;
                    const isEmptyEasyMoneyUserID = getCookie("uniq_user_id") == "undefined" || getCookie("uniq_user_id") == null || getCookie("uniq_user_id") == "" || getCookie("uniq_user_id") == undefined;
                    
                    if (isEmptyEasyMoneyUserID && !isUpmob && getUrlParameter("uniq_user_id") && (responseData.employer.easy_money_user_id == "undefined" || responseData.employer.easy_money_user_id == null || responseData.employer.easy_money_user_id == "" || responseData.employer.easy_money_user_id == undefined)) {
                        registerUser();
                    }
                // registrationFailed("getMyInfoEmployer error = " + JSON.stringify(responseData));
            }
        }, (responseData) => {
            registrationFailed("getMyInfoEmployer error = " + JSON.stringify(responseData));
        })       
    }, []);
    const toastTimerRef = useRef(null);
    const showToast = useCallback((text) => {
        if (getIsAndroidApp()){
            return
        }
        if (toastTimerRef.current) {
            clearTimeout(toastTimerRef.current);
        }
        setToastText(text)
        toastTimerRef.current = setTimeout(() => {
            setToastText("")
            toastTimerRef.current = null
        }, 4000)
    }, [])

    // Очищаем висящий таймер тоста при размонтировании.
    useEffect(() => () => {
        if (toastTimerRef.current) {
            clearTimeout(toastTimerRef.current)
        }
    }, [])
    const registerUser = useCallback(() => {
        if (!getIsAndroidApp() && !getCookie("google_user_id") && !getUrlParameter("google_user_id")) {
            
            if (!window.location.pathname.includes(Pages.auth)) {
                window.location.href = Pages.auth
            }
            return
        }
        var params = getRequestParams()
        var device_id = getUrlParameter('device_id')
        var token_google = getUrlParameter('token_google')
        var uniq_user_id = getUrlParameter('uniq_user_id')
        var api_key = getUrlParameter('api_key')
        var bundle = getUrlParameter('bundle')
        if (bundle != "" && bundle != undefined && bundle != null){
            saveBundle(bundle)
        }
        params.device_id = device_id
        params.token_google = token_google
        params.easy_money_user_id = uniq_user_id
        params.api_key = api_key
        params.bundle = bundle
        if (api_key == "lexus"){
            params.promo_id = "945113"
        } else if (api_key == "QWT"){
            params.promo_id = "2554224"
        } else if (api_key == "QWT2"){
            params.promo_id = "2719566"
        }
        fetch("https://app-coins.ru/api/registerEmployer", getHttpParams(params))
            .then((response) => response.json())
            .then((responseData) => {
                console.log("registerEmployer = ", responseData)
                if (responseData.status == "OK" && responseData.response > 0) {
                    saveRegistrCookie(responseData, device_id, uniq_user_id, api_key);
                    getMyInfo();
                } else {
                    //showAndroidToast("registrationFailed = " + JSON.stringify(responseData.status))
                    registrationFailed("registerUser error = " +JSON.stringify(responseData));
                    
                }
                // if (responseData.response < 0){
                //     registrationFailed();
                // }
            });
    }, [getMyInfo]);

    const getMyNeedRework = useCallback((user) => {

        TasksApi.getOrdersWaitToAction(user.google_user_id, (responseData) => {
            if (responseData.response == 1) {
                var activeTasks = convertNeedReworkOrders(responseData.app_3_days).reverse() 
                var ytTasks = responseData.youtube_orders.proof_orders_youtube
                ytTasks.forEach(element => {
                    element.is_universal = true
                });
                activeTasks.push(...ytTasks)
                setNeedReworkTasks(activeTasks)
            } else {
                setNeedReworkTasks([])
            }
            console.log("getOrdersWaitToAction success = ", responseData)
        }, (responseData) => {
            setNeedReworkTasks([])
        })

    }, []);

    useEffect(() => {
        if (getUrlParameter("file_upload") == "true"){
            setState(prev => ({
                ...prev,
                done: true
            }));
            return
        }
        console.log("componentDidMount index");
        if (getUrlParameter("platform") == "ios") {
            setCookie("platform", "ios");
            if (getUrlParameter("token_google") == "testasd0218938912") {
                setCookie("test_token", "testasd0218938912");
                getMyInfo()
                return
            }
            // getMyInfo();
            // return;
        }
        if (getUrlParameter("google_user_id")) {
            setCookie("google_user_id", getUrlParameter("google_user_id"));
            setCookie("device_id", getUrlParameter("device_id"));
            setCookie("api_key", getUrlParameter("api_key"));
            setCookie("platform", getUrlParameter("platform"));
            getMyInfo();
            return;
        }
        if (!getGoogleId("google_user_id")) {
            registerUser();
        } else {
            getMyInfo();
        }
    }, []);

    if (!state.done && !window.location.pathname.includes(Pages.auth) ) {
        return <Loader />;
    }

    return (
        <div>
            {(window.location.hostname !== 'localhost') && 
                <YMInitializer 
                    accounts={[86575405]}
                    options={{webvisor: false, clickmap:true, trackLinks:true, accurateTrackBounce:true}}
                />
            }
            <div className="app">
                {/* <MaterialMenuAndroid 
                    activeView={state.activeView} 
                    toogleMenu={toogleMenu} 
                    isMenuOpened={state.isMenuOpened} 
                    onMenuClicked={onMenuClicked} 
                    isUpmob={state.isUpmob} 
                    count_money_r={state.count_money_r} 
                    name={state.nick_name} 
                    photo={state.photo_url} 
                    email={state.email} 
                    google_user_id={state.google_user_id}
                /> */}
                <div className="main">
                    {(!getUrlParameter("file_upload") && !(!getIsAndroidApp() && !getCookie("google_user_id") && !getUrlParameter("google_user_id"))) &&
                    <Navbar 
                        toogleMenu={toogleMenu} 
                        onBack={onBack} 
                        isClose={state.isClose} 
                        isUpmob={state.isUpmob} 
                        count_money_r={state.count_money_r}
                        getMyInfo={getMyInfo}
                    />}
                    <section className='main_container_center'>
                        <Suspense fallback={<Loader />}>
                        <Routes>
                            <Route 
                                path={`/${Pages.tasks}`}
                                element={
                                    state.isRegistered && (
                                        <Tasks 
                                            updateMoney={updateMoney} 
                                            wallet_new={state.wallet_new} 
                                            count_money_r={state.count_money_r} 
                                            readyToTasks={state.isRegistered} 
                                            instaUsername={state.instagram_user_name} 
                                            openViewBack={openViewBack} 
                                            onTaskClicked={onTaskClicked} 
                                            isUpmob={state.isUpmob}
                                            info={state.info}
                                        />
                                    )
                                } 
                            />
                           
                            {!getIsAndroidApp() && <Route 
                                path={`/${Pages.auth}`} 
                                element={
                                    <Auth 
                                        onBack={onBack} 
                                        task={state.currentTask} 
                                        updateMoney={updateMoney}
                                        isUpmob={state.isUpmob}
                                    />
                                } 
                            />}
                            <Route 
                                path={`/${Pages.task}`} 
                                element={
                                    <Task 
                                        onBack={onBack} 
                                        task={state.currentTask} 
                                        updateMoney={updateMoney}
                                        
                                        isUpmob={state.isUpmob}
                                    />
                                } 
                            />
                            <Route 
                                path={`/${Pages.task_garanted_review}`} 
                                element={
                                    <TaskNewAndroid 
                                        onBack={onBack} 
                                        task={state.currentTask} 
                                        updateMoney={updateMoney}
                                        
                                        isUpmob={state.isUpmob}
                                    />
                                } 
                            />
                            <Route 
                                path={`/${Pages.task_ios}`} 
                                element={
                                    <TaskIos 
                                        onBack={onBack} 
                                        task={state.currentTask} 
                                        updateMoney={updateMoney}
                                        isUpmob={state.isUpmob}
                                        showToast={showToast}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.active}`} 
                                element={
                                    <ActiveTasks 
                                        onTaskClicked={onTaskClicked} 
                                        info={state.info}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.finished}`} 
                                element={
                                    <FinishedTasks 
                                        onTaskClicked={onTaskClicked} 
                                        info={state.info}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.referals}`}
                                isUpmob={state.isUpmob} 
                                element={<Referals ref_id={state.ref_id}/>} 
                            />

                            <Route 
                                path={`/${Pages.payouts}`} 
                                isUpmob={state.isUpmob}
                                element={<Payouts isUpmob={state.isUpmob} onPayoutClicked={onPayoutClicked}/>} 
                            />

                            <Route 
                                path={`/${Pages.payout}`} 
                                element={
                                    <GetPayout 
                                        isUpmob={state.isUpmob}
                                        wallet_new={state.wallet_new} 
                                        updateMoney={updateMoney} 
                                        min_transfer={state.min_transfer} 
                                        count_money_r={state.count_money_r}
                                        getMyInfo={getMyInfo}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.support}`} 
                                element={
                                    <Support 
                                        isUpmob={state.isUpmob} 
                                        google_user_id={state.google_user_id}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.auth_insta}`} 
                                element={<AuthInsta openViewBack={openViewBack}/>} 
                            />

                            <Route 
                                path={`/${Pages.earn_insta}`} 
                                element={
                                    <EarnInsta 
                                        openViewBack={openViewBack} 
                                        setMoney={setMoney}
                                    />
                                } 
                            />

                            <Route 
                                path={`/${Pages.tiktok_task}`} 
                                element={<EarnTikTok setMoney={setMoney}/>} 
                            />

                            <Route 
                                path={`/${Pages.custom_task}`} 
                                element={
                                    <CustomTask 
                                        task={state.currentTask} 
                                        openViewBack={openViewBack} 
                                        updateMoney={updateMoney}
                                        isUpmob={state.isUpmob}
                                        showToast={showToast}
                                    />
                                } 
                            />
                            <Route 
                                path={`/${Pages.profile}`} 
                                element={
                                    <Profile 
                                        isUpmob={state.isUpmob}
                                        user={state.info} 
                                        showToast={showToast}
                                        openViewBack={openViewBack} 
                                        updateMoney={updateMoney}
                                        onTaskClicked={onTaskClicked}
                                    />
                                } 
                            />
                            <Route 
                                path={`/${Pages.more}`} 
                                element={
                                    <More 
                                        isUpmob={state.isUpmob}
                                        user={state.info} 
                                        openViewBack={openViewBack} 
                                        updateMoney={updateMoney}
                                        onTaskClicked={onTaskClicked}
                                    />
                                } 
                            />
                            <Route 
                                path={`/${Pages.need_rework}`} 
                                element={
                                    <NeedRework 
                                        isUpmob={state.isUpmob}
                                        user={state.info} 
                                        needReworkTasks={needReworkTasks}
                                        openViewBack={openViewBack} 
                                        updateMoney={updateMoney}
                                        onTaskClicked={onTaskClicked}
                                    />
                                } 
                            />
                             <Route 
                                path={`/${Pages.file_upload}`} 
                                element={
                                    <FileUploadPage 
                                       
                                    />
                                } 
                            />
                        </Routes>
                        </Suspense>
                        {isShowBottomMenu() && <BottomMenu needReworkTasks={needReworkTasks} user={state.info}/>}
                        {toastText != "" && <Toast text={toastText}/>}
                    </section>
                </div>
            </div>
        </div>
    );
}

function AppWrapper() {
    if (getIsAndroidApp()){
        return(
            <BrowserRouter>
                <Application />
            </BrowserRouter>
        )
    }
    return (
        <GoogleOAuthProvider clientId='1061951330704-tous6uameesl102ik54gl1nhb5tbl6l1.apps.googleusercontent.com'>
            <BrowserRouter>
                <Application />
            </BrowserRouter>
        </GoogleOAuthProvider>
    );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppWrapper />);

// Глобальные обработчики
window.onResume = () => {
    console.log("onResume index");
    const tasks = [
        window.firstTask,
        window.secondTask,
        window.thirdTask,
        window.fouthTask,
        window.fifthTask,
        window.extraView,
        window.photoTask,
        window.extraFollow,
        window.extraComment,
        window.customTask,
        window.sdkTask
    ];

    tasks.forEach(task => {
        if (task !== undefined) {
            task.onResume();
        }
    });
};

window.handleImage = (image) => {
    if (window.tasks !== undefined) {
        window.tasks.handleImage(image);
    }
};

export default AppWrapper;


